import React from 'react';
import { CtaButton } from './CtaButton';
const rungs = [{
  symbol: '▲',
  name: 'DO',
  line: 'Chooses, talks and follows the steps',
  band: 'bg-sage',
  badge: 'bg-sage text-white'
}, {
  symbol: '■',
  name: 'HELP',
  line: 'One step at a time, modeled, with two choices',
  band: 'bg-gold',
  badge: 'bg-gold text-gold-ink'
}, {
  symbol: '●',
  name: 'FEEL',
  line: 'A hand held, a name said, a warm towel',
  band: 'bg-smoke',
  badge: 'bg-smoke text-white'
}];
const underneath = ['What to watch for', 'Common error and how to fix it', 'Make it easier or harder', 'What to note in the log'];
const pageTypes = ['Run page', 'Ladder page', '8 worksheets per volume', '10 grab-and-go backups', 'Field card'];
export function LookInside() {
  return <section aria-labelledby="look-inside-heading" className="w-full bg-cream text-ink" data-id="element-138" data-mp="18zoeolsocm5w">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-139" data-mp="1dwwy0ppk6w8q">
        <div className="text-center" data-id="element-140" data-mp="a1wkkd3ozs6f">
          <p className="text-[11px] font-semibold uppercase tracking-[0.2em] text-gold-deep" data-id="element-141" data-mp="a0uw96xo196r">
            Look inside
          </p>
          <h2 id="look-inside-heading" className="mt-3 font-display font-bold text-plum text-3xl sm:text-5xl" data-id="element-142" data-mp="k0u3n0icmti1">
            Two pages per activity. One to lead it, one to run it three ways.
          </h2>
          <p className="mx-auto mt-4 max-w-[60ch] text-base text-ink" data-id="element-143" data-mp="3nim28xqzqbp7">
            The Run page tells you how to lead the activity. The Ladder page puts
            DO, HELP and FEEL side by side, so you can use all three in the same
            session.
          </p>
        </div>

        {/* Layout illustration of a Ladder page, built in code */}
        <figure className="mt-10" data-id="element-144" data-mp="3seucpxu8tgq1">
          <div className="overflow-hidden rounded-3xl border border-cream-dark bg-white shadow-card" data-id="element-145" data-mp="34qb6dnur7e0l">
            <div className="flex flex-wrap items-center justify-between gap-2 bg-plum px-5 py-4" data-id="element-146" data-mp="2zsrqykmbkv72">
              <div data-id="element-147" data-mp="13pn0p8ay4kym">
                <span className="block text-[10px] font-semibold uppercase tracking-widest text-gold" data-id="element-148" data-mp="13o23fax8ynx2">
                  Volume 1 · Ladder page
                </span>
                <span className="font-display text-lg font-bold text-white sm:text-xl" data-id="element-149" data-mp="1de4zxl3kuk05">
                  Activity 1 · The Welcome Circle, three ways
                </span>
              </div>
              <span className="text-[12px] font-semibold text-white/75" data-id="element-150" data-mp="kqius8epb7b6">
                ▲ DO · ■ HELP · ● FEEL
              </span>
            </div>

            <div className="grid sm:grid-cols-3" data-id="element-151" data-mp="ppcam7hgnaei">
              {rungs.map((r, i) => <div key={r.name} className={`px-5 py-5 ${i > 0 ? 'border-t border-cream-dark sm:border-l sm:border-t-0' : ''}`} data-id="element-152" data-mp="tp4alvssg889" data-mpi={i}>
                  <span className={`mb-3 block h-1.5 w-12 rounded-full ${r.band}`} data-id="element-153" data-mp="257xbwdd81jdg" />
                  <div className="flex items-center gap-2.5" data-id="element-154" data-mp="2a32ub27f0fws">
                    <span aria-hidden="true" className={`flex h-8 w-8 items-center justify-center rounded-full text-sm font-bold ${r.badge}`} data-id="element-155" data-mp="2k945hnf19jzi">
                      {r.symbol}
                    </span>
                    <span className="font-display text-xl font-bold text-plum" data-id="element-156" data-mp="26hfr1dhbajfd">
                      {r.name}
                    </span>
                  </div>
                  <p className="mt-3 text-[15px] text-ink" data-id="element-157" data-mp="21jxoq5xsv2gc">{r.line}</p>
                </div>)}
            </div>

            <ul className="grid gap-px border-t border-cream-dark bg-cream-dark sm:grid-cols-4" data-id="element-158" data-mp="1wlmhm2yw361t">
              {underneath.map(item => <li key={item} className="bg-cream px-4 py-3 text-[13px] font-semibold text-ink-soft" data-id="element-159" data-mp="1njd557k292ls">
                  {item}
                </li>)}
            </ul>
          </div>
          <figcaption className="mt-3 text-center text-xs text-ink-soft" data-id="element-160" data-mp="3huibijmj7t4t">
            Layout illustration of a Ladder page. The pages in the PDF carry the
            full activity.
          </figcaption>
        </figure>

        <ul className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-161" data-mp="3fzegt35nsffr">
          {pageTypes.map(t => <li key={t} className="rounded-full border border-cream-dark bg-white px-3.5 py-1.5 text-[12px] font-semibold text-ink-soft" data-id="element-162" data-mp="3k0g7gvlifj64">
              {t}
            </li>)}
        </ul>

        <div className="mx-auto mt-8 max-w-md" data-id="element-163" data-mp="3b0tff0eo7ppq">
          <CtaButton data-id="element-164" data-mp="2wb5gg5typ356">Get Memory Care Activity Ready</CtaButton>
        </div>
      </div>
    </section>;
}